import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const StickyInvestBar = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("epic_bar_dismissed") === "true"
  );

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 1.2);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (sel) => {
    if (window.__lenis) window.__lenis.scrollTo(sel);
    else document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });
  };

  if (dismissed) return null;
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="sticky-invest-bar"
          className="fixed bottom-0 inset-x-0 z-40 border-t border-epic-line bg-epic-bg/90 backdrop-blur-md"
        >
          <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-3 flex items-center gap-3 md:gap-4">
            <p className="font-mono text-[10px] md:text-[11px] uppercase tracking-[0.15em] text-epic-sub flex-1 hidden sm:block">
              Note — 10% + conversion at $4.50
              <span className="text-epic-line mx-2">|</span>
              Equity — $3.15/share
            </p>
            <button
              type="button"
              onClick={() => go("#the-raise")}
              data-testid="sticky-note-btn"
              className="bg-epic-accent px-4 md:px-6 py-2.5 text-white font-mono text-[10px] uppercase tracking-[0.15em] transition-colors duration-200 hover:bg-epic-accentHover"
            >
              The Note
            </button>
            <button
              type="button"
              onClick={() => go("#equity")}
              data-testid="sticky-equity-btn"
              className="border border-epic-line px-4 md:px-6 py-2.5 text-epic-text font-mono text-[10px] uppercase tracking-[0.15em] transition-colors duration-200 hover:border-epic-lineHover"
            >
              Equity
            </button>
            <button
              type="button"
              onClick={() => {
                sessionStorage.setItem("epic_bar_dismissed", "true");
                setDismissed(true);
              }}
              data-testid="sticky-dismiss"
              aria-label="Dismiss"
              className="p-2 text-epic-sub hover:text-epic-text transition-colors duration-200"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
